import React, { Fragment, FunctionComponent } from 'react';
import { Grid } from '@material-ui/core';
import { useStyles } from './Banner.styles';
import { useGlobalState } from '../../../common/context/AppContext';
import { WhitelabelPartnerLabel } from '../../../common/interface/IAppConfig';
import { IAppProps } from '../../../common/interface/IAppProvider';

const Banner: FunctionComponent<IAppProps> = (props): JSX.Element => {
    const baseClass = useStyles();
    const hippoTexts = props.config?.resourceBundles['onsa-erhvervsforsikring/'].read();
    const { partner } = useGlobalState();
    const topHeader = hippoTexts['discount.header'];
    const discountPercentage = hippoTexts[`discount.percentage.${partner}`];

    return discountPercentage && partner ? (
        <Fragment>
            <div className={`${baseClass.wrapper} ${baseClass['top']}`}>
                <Grid container direction="row" justifyContent="center" alignItems="center">
                    <span>
                        {topHeader
                            .replace('{discount}', discountPercentage)
                            .replace('{partner}', WhitelabelPartnerLabel[partner])}
                    </span>
                </Grid>
            </div>
        </Fragment>
    ) : (
        <></>
    );
};

export default Banner;
